var map = {
	"./arrow-accordion.svg": 2,
	"./breakfast-croissant.svg": 3,
	"./clock-colored.svg": 4,
	"./clock.svg": 5,
	"./croissant.svg": 6,
	"./facebook.svg": 7,
	"./gift-circle.svg": 8,
	"./giftbox.svg": 9,
	"./instagram.svg": 10,
	"./kaffehaus-symbol.svg": 11,
	"./logo-footer.svg": 12,
	"./phone.svg": 13,
	"./picture-landscape.svg": 14,
	"./quote.svg": 15,
	"./sample.svg": 16,
	"./tiktok.svg": 17,
	"./whatsapp.svg": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;